module.exports = __webpack_public_path__ + "img/益众源.9e509ea3.png";